"use client";
import React from "react";
import { cn } from "@/lib/utils";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "outline" | "subtle" | "destructive";
  size?: "sm" | "md" | "lg";
  loading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className = "", variant = "primary", size = "md", children, loading = false, leftIcon, rightIcon, disabled, ...props }, ref) => {
    const isDisabled = disabled || loading;
    return (
      <button
        ref={ref}
        disabled={isDisabled}
        aria-busy={loading || undefined}
        className={cn(
          "btn",
          variant === "primary" && "btn-primary",
          variant === "secondary" && "btn-secondary",
          variant === "ghost" && "btn-ghost",
          variant === "outline" && "btn-outline",
          variant === "subtle" && "btn-subtle",
          variant === "destructive" && "btn-error",
          size === "sm" && "btn-sm",
          size === "md" && "btn-md",
          size === "lg" && "btn-lg",
          "rounded-lg transition-all",
          className
        )}
        {...props}
      >
        {leftIcon}
        <span className="btn-text">{children}</span>
        {rightIcon}
      </button>
    );
  }
);
Button.displayName = "Button";
